const speechService = {
  playAudio: (url: string): Promise<void> =>
    new Promise((resolve) => {
      const audio = document.querySelector<HTMLAudioElement>("#audioElement");
      if (!audio) {
        resolve();
        return;
      }
      audio.src = url;
      const cleanup = () => {
        audio.removeEventListener("ended", onEnded);
        audio.removeEventListener("error", onError);
      };
      const onEnded = () => {
        cleanup();
        resolve();
      };
      const onError = () => {
        cleanup();
        resolve();
      };
      audio.addEventListener("ended", onEnded);
      audio.addEventListener("error", onError);
      audio.play().catch((e) => {
        audio.pause();
        audio.removeAttribute("src");
        audio.load();
        cleanup();
        resolve();
        console.error(e);
      });
    }),
  stopAudio: async () => {
    const audio = document.querySelector<HTMLAudioElement>("#audioElement");
    try {
      if (audio) {
        audio.pause();
        audio.src = "";
        audio.currentTime = 0;
      }
    } catch (e) {
      console.error(e);
    }
  },
};

export default speechService;
